<template>
    <div> 
        <v-form ref="form">
            <v-row dense>
                <v-col v-if="item.id" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <v-text-field
                        v-model="item.complete_address"
                        outlined
                        dense
                        :class="$css_field"
                        filled
                        readonly
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Endereço</span>
                        </template>
                    </v-text-field>
                </v-col>    
            </v-row>
            <v-row dense>
                <v-col v-if="item.id" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <v-text-field
                        v-model="residentPrincipal"
                        outlined
                        dense
                        :class="$css_field"
                        filled
                        readonly
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Proponente</span>
                        </template>
                    </v-text-field>
                </v-col>    
            </v-row>    
            <v-row dense>
                <v-col v-if="item.id" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <v-select
                        v-model="item.status"
                        :items="statusProfile"
                        :rules="[rules.required]"
                        outlined
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Status</span>
                        </template>
                    </v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <v-currency-field
                        v-model="item.valor_proposta"
                        outlined
                        :rules="[rules.required]"
                        prefix="R$"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Vl Proposta</span>
                        </template>
                    </v-currency-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <v-currency-field
                        v-model="item.comissao"
                        outlined
                        prefix="%"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Comissão</span>
                        </template>
                    </v-currency-field>
                </v-col>
                <v-col v-if="item.setor == 'Locação'" cols="12" xs="12" sm="12"  md="3" lg="3" xl="3">
                    <v-select
                        v-model="item.garantia"
                        :items="items.garantias"
                        outlined
                        :rules="[rules.required]"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Garantia</span>
                        </template>
                    </v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <v-textarea
                        v-model="item.proposta"
                        outlined
                        dense
                        :class="$css_field"
                        :rules="[rules.required]"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Proposta</span>
                        </template>
                    </v-textarea>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <v-btn
                        dark
                        color="secondary"
                        @click="proposal_pdf()"
                        :class="$css_button + ' ma-2'"
                        :block="$vuetify.breakpoint.smAndDown"
                    >
                    PDF proponente
                    </v-btn>

                    <v-btn
                        dark
                        color="secondary"
                        @click="proposal_pdf('property_owners')"
                        :class="$css_button + ' ma-2'"
                        :block="$vuetify.breakpoint.smAndDown"
                    >
                        PDF Proprietário
                    </v-btn>
                </v-col>   
                <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="text-right">    
                    <v-btn
                        dark
                        color="primary"
                        @click="validate"
                        :class="$css_button + ' ma-2'"
                        :block="$vuetify.breakpoint.smAndDown"
                    >
                    Gravar
                    </v-btn>
                </v-col>    
            </v-row>

        </v-form>       
    </div>
</template>

<script>
import { STATUS_ITEMS } from './config_proposals/config_proposals.js' 
import { GARANTIA_LOCACAO_ITEMS } from '@/components/properties/config_properties/config_properties.js'

export default {
    props: {
        object: {
            type: Object, 
            required: true,
            default: () => ({})
        },
    }, 

    watch: {
        object: {
            handler(newVal) {
                // Atualiza o objeto local se o pai atualizar
                this.item = JSON.parse(JSON.stringify(newVal));
            },
            deep: true, // Observa mudanças profundas
            immediate: true // Executa imediatamente ao montar
        }
    },

    computed: {
        me () {
            return this.$store.state.auth.me
        },

        hasData() {
            return this.object && Object.keys(this.object).length > 0;
        },

        residentPrincipal() {
            if (!Array.isArray(this.item.residents)) return ''

            const principais = this.item.residents.filter(resident => resident.principal === "Sim")
            
            return principais.map(resident => resident.nome).join(', ') || ''
        },

        valorProposta() {
            return Math.trunc(this.item.valor_proposta || 0)
        },

        statusProfile(){
            let status = this.items.status;
            if(this.me.profile !== 'Master' && this.me.profile !== 'Gerente'){
                status = ['Nova','Pendente']   
            }
            return status;
        }
    }, 

    data () {
        return {
            item: {},

            items: {
                status: STATUS_ITEMS,
                garantias: GARANTIA_LOCACAO_ITEMS
            },

            params: {
                paginate: 10,
            },
            
            rules: {
                required: value => !!value || 'Obrigatório',
                min:  v => (v && v.length >= 8) || 'Mininmo de 8 caracteres',
                email: value => /.+@.+/.test(value) || 'E-mail precisa ser válido'
            },
        }
    },

    methods: {
        validate () {
            if (this.$refs.form.validate()) {
                this.update(this.item)
            }
        },

        update(item){
            const params = {};
            params.id = item.id
            params.status = item.status
            params.valor_proposta = item.valor_proposta
            params.comissao = item.comissao
            params.proposta = item.proposta      

            this.$store.dispatch('updateProposal', params)
                        .then(response => {
                            //this.item = response.data   
                            this.$snotify.success('Cadastro com sucesso!')
                            this.$emit('callLoadItem', this.item.id)
                        })
                        .catch(error => {
                            console.log(error)
                            this.$snotify.error('Erro no cadastro')
                        })
                   
        },
        
        proposal_pdf(target = null){
            const params = {};
            params.id = this.object.id;
            params.target = target;
            params.file_name = 'Proposta - codigo ' + this.object.codigo + '.pdf';
            this.$store.dispatch('proposal_pdf', params) 
                        .then(response => {
                           this.$snotify.success('Download em andamento');
                        })
            
        }
        
    },
}
</script>

<style scoped>

</style>